import { join } from "node:path";

export const BASE_URL = "https://itsbruno.dev";
export const DATE_FORMAT = "MMMM do, yyyy";
export const POSTS_DIR = join(process.cwd(), "posts");
export const HIDDEN_POSTS = ["automate-cisco-ios-scripts-with-nwiz"];
